import React from 'react';
import { Link, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { Form, Label, Col, Input, NavbarBrand } from 'reactstrap';
import '../css/Login.css';
import { authenticate, checkAuthentication } from '../../api/userapi';
import { Container } from 'reactstrap';
import { SystemInfoView } from '../systemInfo/systemInfoView';
import { customLoadingOverlay } from '../css/CustomLoadingOverlay';
import LoadingOverlay from 'react-loading-overlay-ts'

class Login extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            passwordHidden: true,
            classNamePasswordEye: 'fa fa-eye-slash',
            submitted: false,
            loading: false,
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.toggleShow = this.toggleShow.bind(this);
    }

    componentDidMount() {
        this.props.route.history.push('/')
        this.props.checkAuthenticationConnect();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.currentUser) {
            if (this.props.currentUser.data) {
                if (!this.props.currentUser.data.success && prevState.loading) {
                    this.setState({ loading: false });
                }
            }
        }
    }

    handleChange(e) {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    }

    handleSubmit(e) {
        e.preventDefault();
        const { username, password } = this.state;
        this.setState({ submitted: true });

        if (username && password) {
            this.setState({ loading: true });
            const userLogin = { username: username, password: password };
            this.props.onAuthenticate(userLogin);
        }
    }

    toggleShow(e) {
        e.preventDefault();
        let hidden = !this.state.passwordHidden;
        let className = '';
        if (hidden)
            className = 'fa fa-eye-slash';
        else
            className = 'fa fa-eye';
        this.setState({ passwordHidden: hidden, classNamePasswordEye: className });
    }

    render() {

        const { username, password, submitted, loading } = this.state;
        const isAuthenticated = this.props.isAuthenticated;

        let messages = '';
        if (this.props.currentUser) {
            if (this.props.currentUser.data) {
                if (!this.props.currentUser.data.success) {
                    messages = this.props.currentUser.data.errors.map((item) =>
                        <li key={item.errorCode} >{item.message}</li>
                    );
                }
            }
        }

        if (isAuthenticated) {
            this.props.route.history.push('/secure/gifts')
            return <Redirect to='/secure/gifts' />;
        }

        return (
            <Container>
                <LoadingOverlay active={loading} spinner styles={customLoadingOverlay} >

                    <div className="col-md-12">
                        <br></br> <br></br>
                        <br></br> <br></br>
                        <div className="d-flex justify-content-center">
                            <NavbarBrand tag={Link} to="#"><img src="./aaa_logo.png" alt="logo" className="title-logo" /></NavbarBrand>
                        </div>
                        <div className="d-flex justify-content-center">
                            <h5 className="title-login-logo"> GIFT CENTER PORTAL </h5>
                        </div>
                        <div className="d-flex justify-content-center">
                            <SystemInfoView environment={this.state.settings} ></SystemInfoView>
                        </div>
                        <Col> <br></br> <br></br></Col>
                        <div className="d-flex justify-content-center">
                            <Form name="form" onSubmit={this.handleSubmit} className="col-md-5 user-text">
                                <div className={'form-group' + (submitted && !username ? ' has-error' : '')}>
                                    <Label className={"mt-4"} htmlFor="username"> <strong>Email address</strong></Label>
                                    <Input
                                        type="email"
                                        id="username"
                                        name="username"
                                        className='input-editable'
                                        value={username}
                                        onChange={this.handleChange}
                                        autoComplete="email"
                                    />
                                    {submitted && !username &&
                                        <span className="help-block">Value is required.</span>
                                    }
                                </div>
                                <div className={'form-group' + (submitted && !password ? ' has-error' : '')}>
                                    <Label className={"mt-4"} htmlFor="password"> <strong>Password</strong></Label>
                                    <div className="input-group" id="show_hide_password">
                                        <Input
                                            type={this.state.passwordHidden ? "password" : "text"}
                                            id="password"
                                            name="password"
                                            className='input-editable input-password'
                                            value={password}
                                            onChange={this.handleChange}
                                        />
                                        <div className="input-group-addon eye-pass">
                                            <Link to='#' onClick={this.toggleShow} ><i className={this.state.classNamePasswordEye} aria-hidden="true"></i></Link>
                                        </div>
                                    </div>
                                    {submitted && !password &&
                                        <span className="help-block">Value is required.</span>
                                    }
                                </div>
                                <div className="form-group">
                                    <div className="row">
                                        <div className="col-md-6">

                                        </div>
                                        <div className="col-md-6">
                                            <Link to='/forgotpassword' className="forgot-password"> Forgot your password? </Link>
                                        </div>
                                        <ul className="errors-list">{messages}</ul>
                                    </div>
                                </div>
                                <div className="form-group">
                                    <div className="d-flex justify-content-center">
                                        <button className="btn mt-4" disabled={loading}>SIGN IN</button>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </div>
                </LoadingOverlay>
            </Container>
        );
    }
}

export default connect(
    state => {
        return {
            currentUser: state.data.currentUser,
            isAuthenticated: state.data.isAuthenticated
        }
    },
    dispatch => ({
        onAuthenticate: (userLogin) => { dispatch(authenticate(userLogin)) },
        checkAuthenticationConnect: () => { dispatch(checkAuthentication()) }
    })
)(Login);